import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import MobileReponseShow from "pages/Dashboard/DashboardScreen/MobileReponseShow";
import Routes from "routes";

import MediaQuery from "react-responsive";

const App = () => {
  return (
    <div>
      {/* <MediaQuery minDeviceWidth={0} maxDeviceWidth={600}>
        <MobileReponseShow />
      </MediaQuery>
       */}
      <Routes />
      
      {/* <MediaQuery minDeviceWidth={601}>
        <Routes />
      </MediaQuery> */}
    </div>
  );
};

export default App;
